import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminLanguage } from '../AdminLanguageContext';
import { CLIENT_URL } from '../config';
import './Layout.css';

export { CLIENT_URL };

const NAV = [
  { to: '/',              icon: '📊', labelKey: 'dashboard' },
  { to: '/users',         icon: '👥', labelKey: 'users' },
  { to: '/tasks',         icon: '📋', labelKey: 'tasks' },
  { to: '/bids',          icon: '💰', labelKey: 'bids' },
  { to: '/submissions',   icon: '📎', labelKey: 'submissions' },
  { to: '/marketplace',   icon: '🛒', labelKey: 'marketplace' },
  { to: '/reviews',       icon: '⭐', labelKey: 'reviews' },
  { to: '/reports',       icon: '🚩', labelKey: 'reports' },
  { to: '/posts',         icon: '💬', labelKey: 'posts' },
  { to: '/categories',    icon: '🗂️',  labelKey: 'categories' },
  { to: '/announcements', icon: '📢', labelKey: 'announcements' },
  { to: '/points',        icon: '🏆', labelKey: 'points' },
  // 财务（支付系统）
  { to: '/finance',       icon: '💹', labelKey: 'finance' },
  { to: '/wallets',       icon: '💰', labelKey: 'wallets' },
  { to: '/orders',        icon: '📦', labelKey: 'orders' },
  { to: '/disputes',      icon: '!', labelKey: 'disputes' },
  { to: '/checkout-requests', icon: '🧾', labelKey: 'checkoutRequests' },
  { to: '/withdrawals',   icon: '💸', labelKey: 'withdrawals' },
  { to: '/settings',      icon: '⚙️', labelKey: 'settings' },
];

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { language, copy, setLanguage } = useAdminLanguage();
  const layoutCopy = copy.layout;
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/login');
  };

  return (
    <div className={`layout ${collapsed ? 'collapsed' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-logo">
          <span className="logo-icon">S</span>
          {!collapsed && <span className="logo-text">{layoutCopy.product}</span>}
        </div>
        <nav className="sidebar-nav">
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">{n.icon}</span>
              {!collapsed && <span className="nav-label">{layoutCopy.nav[n.labelKey]}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="nav-item" onClick={() => setCollapsed(c => !c)}>
            <span className="nav-icon">{collapsed ? '→' : '←'}</span>
            {!collapsed && <span className="nav-label">{collapsed ? layoutCopy.expand : layoutCopy.collapse}</span>}
          </button>
          <button className="nav-item logout-btn" onClick={handleLogout}>
            <span className="nav-icon">🚪</span>
            {!collapsed && <span className="nav-label">{layoutCopy.logout}</span>}
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <div className="topbar-title">{layoutCopy.title}</div>
          <div className="topbar-actions">
            <div className="admin-language-switch" aria-label={layoutCopy.language}>
              <button
                type="button"
                className={language === 'zh' ? 'active' : ''}
                onClick={() => setLanguage('zh')}
              >
                中文
              </button>
              <button
                type="button"
                className={language === 'en' ? 'active' : ''}
                onClick={() => setLanguage('en')}
              >
                EN
              </button>
            </div>
            <a href={CLIENT_URL} target="_blank" rel="noreferrer" className="topbar-link">
              {layoutCopy.visitClient} →
            </a>
          </div>
        </div>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
